// Vendors
import React, { useState, useEffect } from 'react'
const { formatText, FormattedText } = require('core/i18n').i18n;
import moment from 'moment';

// Components
import OKModal from 'components/commons/OKModal/OKModal';

// Utilities
import { isPrivateEquityTest, isPrivateEquityTestExpired } from 'mifid/utilities/mifidPrivateEquityHelper';

// Constants
import { BROKER_CONVENIENCE_MIFID_TEST_EXTERNAL_TRANSFER_FUND } from 'constants/index';

// @tagging
import { taggingEventHandled } from "utilities/taggingEventHandled";
import { PROC_BROKER_CONVENIENCE_TEST } from "utilities/tagging";

const BrokerConvenienceTestInitialModal = ({ immBrokerConvenienceMiFIDTest, history }) => {
    useEffect(() => {
        const immTestToEvaluate = immBrokerConvenienceMiFIDTest.getIn(['mifidv2','testToEvaluate']);
        const testToEvaluateId = immTestToEvaluate.get('tipoTest');
        if (isPrivateEquityTest(testToEvaluateId)) {
            const reason = immTestToEvaluate.get('reason');
            if (reason === "0") {
                taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'initialModalRenderFirstTime');
            } else if(reason === "1") {
                taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'initialModalRenderReproved');
            }
        }
    }, [])
    
    const [isOpen, setIsOpen] = useState(true);
    const immTestToEvaluate = immBrokerConvenienceMiFIDTest.getIn(['mifidv2','testToEvaluate']);
    const testToEvaluateId = immTestToEvaluate.get('tipoTest');
    if (isPrivateEquityTest(testToEvaluateId)) {
        const onCancel = () => {
        const operationType = immBrokerConvenienceMiFIDTest.get('operationType');

        switch (operationType) {
            case BROKER_CONVENIENCE_MIFID_TEST_EXTERNAL_TRANSFER_FUND:
                const externalTransferFundState = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'externalTransferFundState']);
                this.props.onCancelToExternalTransferFund(externalTransferFundState, history);

                break;
            default: {
                const cancelPath = immBrokerConvenienceMiFIDTest.get('cancelPath');

                if (!immBrokerConvenienceMiFIDTest.get('isCancelPathAbsolute')) {
                    history.replace(cancelPath); // This doesn't consider the domain
                } else {
                    window.location.replace(cancelPath); // Redirects to URLs with different hostnames
                }
                break;
            }
        }
        }
        const reason = immTestToEvaluate.get('reason')
        const lastExecutionDate = immTestToEvaluate.get('lastDateTest');
        let description, primaryButtonClick, onCloseCallback;
        switch (reason) {
            case "0":
                description = (
                    <div>
                        <p>
                            <FormattedText value="broker-convenienceMifidTestInitialModal_alternativeFunds_firstTimeTestContent" />
                        </p>
                    </div>
                );
                primaryButtonClick = () => {
                    setIsOpen(false)
                    taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'initialModalContinueFirstTime');
                };
                onCloseCallback = () => setIsOpen(false);
                break;
            case "1":
                description = (
                    <div>
                        <p>
                            <FormattedText value="broker-convenienceMifidTestInitialModal_alternativeFunds_repeatTestContent" />
                        </p>
                    </div>
                );
                primaryButtonClick = () => {
                    taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'initialModalContinueReproved');
                    onCancel();
                }
                onCloseCallback = () => {};
                break;
            case "2":
                description= null;
                break;
            case "3":
            default:
                description = null;
                break;
        }
        if(lastExecutionDate && isPrivateEquityTestExpired(lastExecutionDate)){
            return null;
        }
        return !!description ? (
            <OKModal
                isOpen={isOpen}
                title={formatText(
                    "broker-convenienceMifidTestInitialModal_alternativeFunds_title"
                )}
                titleAlignment="center"
                description={description}
                descriptionAlignment="left"
                footerType="navigation"
                primaryButtonText={formatText(
                    "broker-convenienceMifidTestInitialModal_alternativeFunds_button"
                )}
                onPrimaryButtonClick={primaryButtonClick}
                onCloseCallback={onCloseCallback}
            />
        ) : null;
    } else {
        return null;
    }
}

export default BrokerConvenienceTestInitialModal